/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2018-12-29 17:34:06
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-26 14:14:48
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill';//safari,ie等浏览器没有内置Promise对象，通过polyfill可解决
// import 'ant-design-vue/dist/antd.less'

import Vue from 'vue'
import './core/lazy_use'
import App from './App'
import router from './router'
import { VueAxios } from '@/utils/request'
import localstorage from './localstorage'
import store from './store'

import './mock'

import bootstrap from './core/bootstrap'
import '@/permission' // permission control
import '@/utils/filter' // base filter

import Axios from 'axios'
import trim from '@/components/Tools/trim'
import md5 from 'js-md5';

Vue.prototype.$md5 = md5;
// import Es6Promise from 'es6-promise'
// Es6Promise.polyfill()

Vue.prototype.$localstorage = localstorage

Vue.prototype.$trim=trim

Axios.defaults.baseURL = '/api'
Axios.defaults.headers.post['Content-Type'] = 'application/json';

Vue.config.productionTip = false

Vue.prototype.$axios = Axios    //全局注册，使用方法为:this.$axios

Vue.use(VueAxios)


new Vue({
  router,
  store,
  beforeCreate() {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js